<template>
    <div class="bright container-fluid py-2">
        <router-view @childrenRoute="hideNonChildren" />
        <div class="row" v-if="hasPageChild==0">            
            <el-card class="pb-4 pt-1" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-12">
                        <el-form  class="mt-2" label-position="top" label-width="100px">
                            <div class="row">
                                <div class="col-md-2">	
                                    <el-form-item label="Bulan:">
                                        <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                            <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="col-md-2">	
                                    <el-form-item label="Tahun:" style="min-width:85px;">
                                        <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                            <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="col-md-2">	
                                    <el-form-item label=" ">
                                        <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-card>        
        </div>
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import {Rainbow, FuelColor, Config,Penanggalan, AxiosWithJar } from '@/utility.js'


export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
	},

	data() {
		return {
           
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,
            
            loading: {
                table: false,
            }
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
    },
    methods: {
        applyFilter() {
            localStorage.setItem('performanceDefaultMonth', this.month)
            localStorage.setItem('performanceDefaultYear', this.year)
            //console.log('filter period')
            this.showMessageBox()
        },
        setDefaultPeriod() {
            // Mengecek apakah kunci 'username' sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                console.log('period belum ada di localStorage');
            }
        },

        showMessageBox() {
            this.$alert('Periode berhasil di ubah.', 'Success', {
            confirmButtonText: 'OK',
            callback: action => {
                this.$message({
                type: 'info',
                message: action == 'cancel' ? `Sukses, Periode berhasil di ubah` : 'Sukses, Periode berhasil di ubah'
                });
            }
            });
        }
    },
}
</script>